import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import clxBind from 'classnames/bind';
import styles from './styles.module.scss';

const clx = clxBind.bind(styles);

export const CLOSE_TIMEOUT = 300;

export default class Modal extends React.Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    closeTimeoutMS: PropTypes.number,
    className: PropTypes.string,
    overlayClassName: PropTypes.string,
  };

  static defaultProps = {
    isOpen: false,
    closeTimeoutMS: CLOSE_TIMEOUT,
    className: undefined,
    overlayClassName: undefined,
  };

  render() {
    const { className, overlayClassName, ...props } = this.props;

    return (
      <ReactModal
        className={{
          base: clx('modal', className),
          afterOpen: styles['modal-after-open'],
          beforeClose: styles['modal-before-close'],
        }}
        overlayClassName={{
          base: clx(styles['overlay'], overlayClassName),
          afterOpen: styles['overlay-after-open'],
          beforeClose: styles['overlay-before-close'],
        }}
        contentLabel=""
        ariaHideApp={false}
        {...props}
      />
    );
  }
}
